import { render, staticRenderFns } from "./SendMessageDropdown.vue?vue&type=template&id=1a3fbc55&scoped=true"
import script from "./SendMessageDropdown.vue?vue&type=script&lang=js"
export * from "./SendMessageDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3fbc55",
  null
  
)

export default component.exports